import type { CustomCellRendererProps } from '@mint-lib/ag-grid/react';

import { Delete, OverflowMenuVertical } from '@mint-lib/icons';
import { Button } from '@mint-lib/tw-components';

import { USER_STATUS } from '../../../constants/userTableV2.js';
import ActionsCellSkeleton from '../../tableCommons/ActionsCellSkeleton.jsx';
import type { UserTableV2Row } from '../datasource.js';
import { isUserUpdating, type UserTableV2GridContext } from '../gridContext.js';

type Props = CustomCellRendererProps<
  UserTableV2Row,
  unknown,
  UserTableV2GridContext
>;

const ActionsCell = (props: Props) => {
  const isUpdating = isUserUpdating(props.context, props.data?.id);
  const user = props.data;

  if (!user || isUpdating) {
    return <ActionsCellSkeleton />;
  }

  const handleOpenContextMenu = () => {
    props.api.showContextMenu({
      ...props,
      source: 'ui',
      rowNode: props.node,
    });
  };

  if (user.status === USER_STATUS.DeactivatedSystem) {
    return (
      <Button
        className="flex h-full w-full cursor-pointer items-center justify-center fill-warning-dark hover:fill-warning-dark"
        icon
        variant="plain"
        size="small"
        color="warning"
        aria-label="remove user"
        onClick={() => props.context.onRemoveClick(user)}
      >
        <Delete />
      </Button>
    );
  }

  return (
    <Button
      className="flex h-full w-full cursor-pointer items-center justify-center"
      icon
      variant="plain"
      size="small"
      color="primary"
      aria-label="open context menu"
      onClick={handleOpenContextMenu}
    >
      <OverflowMenuVertical />
    </Button>
  );
};

export default ActionsCell;
